query getInventoryWeights {
  inventoryWeights {
    ...fullInventoryWeights
  }
}
